/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim
=========================================================
*/

import { ReactNode } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard components
import MDBox from "mdComponents/MDBox";

// Layout components
import PageLayout from "components/LayoutContainers/PageLayout";

// Authentication footer
import Footer from "layouts/authentication/components/Footer";

interface BasicLayoutNewProps {
  image: string;
  children: ReactNode;
  wide?: boolean;
}

const BasicLayoutNew = ({
  image,
  children,
  wide = false,
}: BasicLayoutNewProps) => {
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba } }) =>
            image &&
            `${linearGradient(
              rgba("#02070d", 0.72),
              rgba("#071420", 0.62)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          "&:after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(circle at 18% 18%, rgba(22, 141, 255, 0.20), transparent 34%), linear-gradient(180deg, rgba(2, 7, 13, 0.08), rgba(2, 7, 13, 0.42))",
          },
        }}
      />

      <MDBox
        px={{ xs: 1.5, sm: 2, md: 3 }}
        py={{ xs: 3, md: 5 }}
        width="100%"
        flex="1"
        mx="auto"
        position="relative"
        zIndex={1}
      >
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          minHeight="calc(100vh - 110px)"
          height="100%"
        >
          <Grid
            item
            xs={11}
            sm={wide ? 11 : 9}
            md={wide ? 10 : 5}
            lg={wide ? 9 : 4}
            xl={wide ? 8 : 3}
          >
            {children}
          </Grid>
        </Grid>
      </MDBox>

      <Footer light />
    </PageLayout>
  );
};

export default BasicLayoutNew;
